import React from 'react';
import PropTypes from 'prop-types';
import {ReportBuildingInfoDetailsEnum} from 'common/proxies/enum-proxy';
import Card from 'common/components/card';
import CardAttributes from 'common/components/card-attributes';
import CardContent from 'common/components/card-content';
import CardConfig from 'common/components/card-config';
import CardHeader from 'common/components/card-header';
import {formatUnits} from 'common/utils/units-util';
import {t} from 'common/utils/translation-util';
import MapboxFixedMap from 'common/components/mapbox-fixed-map';

import './index.scss';

const getOccupancySchedule = (value) =>
  value.map(
    ({day, open, close, occupants}) =>
      (open || close || occupants) && (
        <div className={'BuildingOccupancySchedule'} key={day}>
          <div className={'BuildingOccupancySchedule--Day'}>{day}</div>
          <div className={'BuildingOccupancySchedule--TimeRange'}>
            <div className={'BuildingOccupancySchedule--TimeRange--Open'}>
              {open || 'None'}
            </div>
            {close && (
              <div className={'BuildingOccupancySchedule--TimeRange--To'}>
                {' - '}
              </div>
            )}
            {close && (
              <div className={'BuildingOccupancySchedule--TimeRange--Close'}>
                {close}
              </div>
            )}
          </div>
          <div className={'BuildingOccupancySchedule--Occupants'}>
            {occupants ? t(`, ${occupants} occupants`) : ''}
          </div>
        </div>
      ),
  );

const BuildingInfoCard = ({
  buildingInfo,
  connectDragSource,
  disableConfig,
  report,
}) => {
  const {latitude, longitude, attributes} = buildingInfo;
  let name;
  const nameIndex =
    attributes &&
    attributes.findIndex(
      (el) => el && el.id === ReportBuildingInfoDetailsEnum.NAME.id,
    );
  if (nameIndex > -1) {
    name = attributes.splice(nameIndex, 1)[0];
  }

  const map = connectDragSource(
    <div className={'mapbox-container'}>
      {latitude && longitude ? (
        <MapboxFixedMap
          height={100}
          latitude={latitude}
          longitude={longitude}
          markerSize={'m'}
          maxWidth={900}
        />
      ) : null}
      {(name && name.value) || report.warnings ? (
        <CardHeader
          disableConfig={disableConfig}
          reportId={report.id}
          title={name ? name.value : ''}
          warnings={report.warnings}
        />
      ) : null}
    </div>,
  );

  const config = !disableConfig ? (
    <CardConfig disableDownload={true} reportId={report.id} />
  ) : null;

  const formattedAttributes = attributes
    ? attributes.map(({id, label, value}) => {
        let displayValue = value;
        if (id === ReportBuildingInfoDetailsEnum.OCCUPANCY_SCHEDULE.id) {
          displayValue = getOccupancySchedule(value);
        } else if (id === ReportBuildingInfoDetailsEnum.AREA.id) {
          const {area, unit} = value;
          displayValue = (
            <span>
              {area} {formatUnits(unit)}
            </span>
          );
        }

        return {
          label,
          value: displayValue,
        };
      })
    : [];

  return (
    <div className={'BuildingInfoCard'}>
      <Card className={'Card--corner-menu'}>
        {map}
        {config}
        <CardContent>
          <CardAttributes attributes={formattedAttributes} />
        </CardContent>
      </Card>
    </div>
  );
};

BuildingInfoCard.propTypes = {
  buildingInfo: PropTypes.object.isRequired,
  connectDragSource: PropTypes.func,
  disableConfig: PropTypes.bool,
  report: PropTypes.object.isRequired,
};

BuildingInfoCard.defaultProps = {
  buildingInfo: null,
  connectDragSource: (x) => x,
  disableConfig: true,
  report: null,
};

export default BuildingInfoCard;
